import React from 'react';
import { Theme, styled } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { SpriteIcon } from 'src/config/api/models/FontAwesome';

type Props = {
  icon?: SpriteIcon;
  submitText: string;
  hasCancelButton?: boolean;
  cancelText?: string;
  submitCallback?: () => void;
  cancelCallback?: () => void;
  disableSubmit?: boolean;
  disableCancel?: boolean;
};

const StyledButtonGroup = styled('footer')<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'end',
  gap: theme.spacing(2),
  borderTop: `1px solid #EAE6DC`,
  height: theme.config.bottomBarHeight,
	alignItems: 'center',
	padding: '12px 16px'
}));

export const BottomBar = ({
  icon,
  submitText,
  hasCancelButton,
  cancelText,
  submitCallback,
  cancelCallback,
  disableSubmit = false,
  disableCancel = false,
}: Props) => (
  <StyledButtonGroup>
    {hasCancelButton && (
      <Button disabled={disableCancel} variant="text" onClick={cancelCallback} style={{ height: '36px'}}>
        {cancelText}
      </Button>
    )}
    <Button
			style={{ height: '36px'}}
			size='small'
			disabled={disableSubmit}
			color="primary"
			variant="contained"
			type="submit"
			onClick={submitCallback}
			disableElevation={true}
			startIcon={icon && <FontAwesomeSpriteIcon iconSize="md" icon={icon} color="white" />}
    >
      {submitText}
    </Button>
  </StyledButtonGroup>
);
